module.exports = __webpack_public_path__ + "img/brand (5).907e7664.svg";